import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import axios from 'axios';
import { Catalog, ScrollToTop } from '@netexknowledge/smart-components';
import { CMI5, LIBRARY, PARAMS } from '../../const';
import { getGuestSessionFromStorage, getGuestTokenFromStorage, getLanguageFromStorage } from '../../shared';
import { getDefaultLanguage } from '../../services/translate/translateService';
import * as activityService from '../../services/domain/activityService';
import {
  API_BACKOFFICE_CUSTOMERS_BOOKS_METAS,
  API_BACKOFFICE_SCHOOL_BOOKS,
  API_CMS_CUSTOMERS_ACTIVITIES_PREVIEW,
  API_CMS_CUSTOMERS_RESOURCES_PREVIEW,
  API_CMS_SEARCH
} from '../../services/api/apiConst';

const DISABLE_ALL_IMPORTS = {
  book: true,
  unit: true,
  lesson: true,
  activity: true,
  file: true
};

class GuestCatalogContainer extends React.Component {
  static propTypes = {
    // classroom-be devuelve clientId/schoolId como string (ver GuestValidateResponse/GuestSessionResponse)
    customerId: PropTypes.string,
    schoolId: PropTypes.string
  };

  getActivityTypesFilterFields = () => {
    const { locale } = this.props;
    const fields = [];

    Object.keys(LIBRARY.ACTIVITY_TYPE).forEach(key => {
      const activityType = LIBRARY.ACTIVITY_TYPE[key];
      fields.push({
        label: I18n._getTranslations()[locale]['activityTypes'][activityType],
        value: activityType,
        icon: 'custom-icons-' + activityService.getActivityIcon(activityType)
      });
    });

    return fields;
  };

  getFileTypesFilterFields = () => {
    const { locale } = this.props;
    const fields = [];

    Object.keys(LIBRARY.FILE_TYPES).forEach(key => {
      const fileType = LIBRARY.FILE_TYPES[key];
      fields.push({
        label: I18n._getTranslations()[locale]['fileTypes'][fileType],
        value: fileType
      });
    });

    return fields;
  };

  render() {
    const { customerId, schoolId, locale, skinUrl } = this.props;

    return (
      <>
        <ScrollToTop contentQuerySelector="[class^=slide-height-][aria-hidden='false']"></ScrollToTop>
        <Catalog
          language={locale}
          authToken={getGuestTokenFromStorage()}
          classroomsUrl=""
          previewUrl={API_CMS_CUSTOMERS_ACTIVITIES_PREVIEW.replace(PARAMS.CUSTOMER, customerId)}
          filePreviewUrl={API_CMS_CUSTOMERS_RESOURCES_PREVIEW.replace(PARAMS.CUSTOMER, customerId)}
          bookDetailsUrl={API_BACKOFFICE_SCHOOL_BOOKS.replace(PARAMS.SCHOOL, schoolId).replace(PARAMS.BOOK, ':id')}
          skinUrl={skinUrl || ''}
          clientMetadataUrl={API_BACKOFFICE_CUSTOMERS_BOOKS_METAS.replace(PARAMS.CUSTOMER, customerId)}
          competenciesUrls={[]}
          availableResourceTypes={['all', 'book', 'unit', 'lesson', 'activity', 'file']}
          selectorNames={[]}
          translationsObject={I18n._getTranslations()[locale]?.catalog}
          axios={axios}
          activityTypesFilterFields={this.getActivityTypesFilterFields()}
          fileTypesFilterFields={this.getFileTypesFilterFields()}
          searchUrl={API_CMS_SEARCH.replace(PARAMS.CUSTOMER, customerId)
            .replace(PARAMS.SCHOOL, schoolId)
            .replace(PARAMS.TYPE, ':type')}
          activityTypeBookId={CMI5.ACTIVITY_TYPE.COURSE}
          activityTypeUnitId={CMI5.ACTIVITY_TYPE.UNIT}
          activityTypeLessonId={CMI5.ACTIVITY_TYPE.LESSON}
          activityTypeDefaultId={CMI5.ACTIVITY_TYPE.DEFAULT}
          fileTypeId={CMI5.ACTIVITY_TYPE.RESOURCE}
          hideFilters={false}
          disableImports={DISABLE_ALL_IMPORTS}
          defaultResourceType="book"
        />
      </>
    );
  }
}

function mapStateToProps(state) {
  const { resolvedClient, session } = state.guest;
  // En una recarga de página el estado redux "guest" aún no se ha rehidratado desde storage
  // (GuestCatalogPage lo hace en componentDidMount), así que se usa como respaldo para el primer render.
  const storedSession = getGuestSessionFromStorage();
  return {
    customerId:
      (session && session.clientId) ||
      (resolvedClient && resolvedClient.clientId) ||
      (storedSession && storedSession.clientId),
    schoolId:
      (session && session.schoolId) ||
      (resolvedClient && resolvedClient.schoolId) ||
      (storedSession && storedSession.schoolId),
    locale: state.i18n.locale || getLanguageFromStorage() || getDefaultLanguage(),
    skinUrl: state.theme.skinUrl
  };
}

export default connect(mapStateToProps)(GuestCatalogContainer);
